import plyr from "plyr";
import "ff-query";
import "tarteaucitron";
import { local } from "brownies";

function getScript(source, callback) {
  var script = document.createElement("script");
  var prior = document.getElementsByTagName("script")[0];
  script.async = 1;

  script.onload = script.onreadystatechange = function (_, isAbort) {
    if (
      isAbort ||
      !script.readyState ||
      /loaded|complete/.test(script.readyState)
    ) {
      script.onload = script.onreadystatechange = null;
      script = undefined;

      if (!isAbort && callback) setTimeout(callback, 0);
    }
  };

  script.src = source;
  prior.parentNode.insertBefore(script, prior);
}

(function (window) {
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Variables
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var w = window,
    d = document,
    html = d.documentElement,
    $html = $(html),
    $body = $("body"),
    $header = $("#header"),
    $nav = $("#nav"),
    $nav_i = $nav.find("li"),
    $main = $("#main"),
    $stickyBars = $main.find(".stickyBar"),
    $langsSwitcher = $("#langsSwitcher"),
    $header_logo = $header.find(".header_logo"),
    windowH,
    windowW,
    headerFixedH,
    scrollT,
    sauvScroll = 0,
    adminBar_h = 0,
    serveur_test = d.location.hostname == "localhost",
    is_requeting = false;

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Dimensions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function get_fixed_header_height() {
    if ($header.css("position") == "fixed") {
      return $header.outerHeight();
      // } else if($nav.css('position') == 'fixed') {
      //   return $nav.outerHeight();
    } else {
      // return 0;
      return $nav.outerHeight();
    }
  }

  function update_dimensions() {
    windowH = w.innerHeight;
    windowW = w.innerWidth;
    headerFixedH = get_fixed_header_height();
    update_scroll();
  }

  function update_scroll() {
    scrollT = w.pageYOffset;
  }

  function update_adminbar() {
    // $adminBar = !$adminBar.length && has_adminBar ? $('#wpadminbar') : $adminBar;
    // adminBar_h = $adminBar.length && $adminBar.is(':visible') ? $adminBar.height() : 0;
    adminBar_h =
      parseInt($html.css("margin-top")) + parseInt($body.css("margin-top"));
  }

  update_dimensions();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Helper functions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Easing functions (inspired by http://gizma.com/easing/)
  function getQueryVariables(url) {
    var query = url.split("?");
    var vars = (query.length > 1 ? query[1] : "").split("&");
    var returnVars = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      returnVars[pair[0]] = pair[1] ? pair[1] : null;
    }
    return returnVars;
  }
  var easing = {
    linear: function (t) {
      return t;
    },
    easeInQuad: function (t) {
      return t * t;
    },
    easeOutQuad: function (t) {
      return t * (2 - t);
    },
    easeInOutQuad: function (t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function (t) {
      return t * t * t;
    },
    easeOutCubic: function (t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function (t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function (t) {
      return t * t * t * t;
    },
    easeOutQuart: function (t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function (t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function (t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function (t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function (t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
  };

  //ScrollTo animate
  function scrollTo(Y, duration, easingFunction, callback) {
    var start = Date.now(),
      from = window.pageYOffset;

    if (from === Y) {
      if (callback) callback();
      return;
    }

    if (!easingFunction) easingFunction = easing.linear;

    function scroll(timestamp) {
      var currentTime = Date.now(),
        time = Math.min(1, (currentTime - start) / duration),
        easedT = easingFunction(time);

      const yPos = easedT * (Y - from) + from;
      window.scrollTo(0, yPos);

      if (time < 1) requestAnimationFrame(scroll);
      else if (callback) callback();
    }

    requestAnimationFrame(scroll);
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Scroll jusqu'a un element
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function scrollToEl($el, marge) {
    var offsetEl = 0;
    if (marge) {
      offsetEl -= marge;
    }
    if ($el.length) {
      offsetEl += $el.offset().top - adminBar_h;
      if ($stickyBars.length && $el.closest("[data-fixed-container]").length) {
        offsetEl -= $stickyBars.innerHeight();
      }
      offsetEl += 2;
      var elMargin = parseInt($el.css("marginTop"));
      var elPadding = parseInt($el.css("paddingTop"));
      if (!elPadding && elMargin) {
        offsetEl -= elMargin;
      } else if (!elPadding) {
        elMargin = parseInt($el.prev().css("marginBottom"));
        elPadding = parseInt($el.prev().css("paddingBottom"));
        if (elPadding) {
          offsetEl -= elPadding;
        } else if (elMargin) {
          offsetEl -= elMargin;
        }
      }
    }
    if (offsetEl < scrollT && headerFixedH) {
      offsetEl -= headerFixedH;
    }
    scrollToOffset(offsetEl);
  }

  function scrollToOffset(offsetEl) {
    jQuery("html, body").animate(
      {
        scrollTop: offsetEl,
      },
      300
    );
  }

  function scroller_init($cont) {
    $cont = $cont && $cont.length ? $cont : $body;
    var $directElToScroll = $cont.find(".js-scroll-to-me").first();
    if ($directElToScroll.length) scrollToEl($directElToScroll);

    $cont.find('a.js-scroller[href^="#"]').on("click", function (event) {
      var $this = $(this);
      var $target = $($this.attr("href"));
      if ($target.length && $this.attr("data-scroll-parent")) {
        $target = $target.closest($this.attr("data-scroll-parent"));
      }
      if ($target.length) {
        event.preventDefault();
        scrollToEl($target);
      }
    });
  }
  scroller_init();

  //Ajax
  function ajax(args) {
    // args { url, params, json, method, before, success, error, always }
    // For POST args.params must be a formData
    if (args.before) {
      args.before();
    }
    var request = new XMLHttpRequest();
    if (args.method && args.method.toLowerCase() == "post") {
      request.open(args.method, args.url, true);
    } else {
      args.method = "GET";
      args.params = args.params
        ? (args.url.indexOf("?") === -1 ? "?" : "&") + args.params
        : "";
      request.open(args.method, encodeURI(args.url + args.params), true);
    }
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        var data = args.json
          ? JSON.parse(request.responseText)
          : request.responseText;
        if (args.success) {
          args.success(data);
        }
        if (args.always) {
          args.always(data);
        }
      } else {
        // We reached our target server, but it returned an error
        if (args.error) {
          args.error();
        }
        if (args.always) {
          args.always(false);
        }
      }
    };
    request.onerror = function () {
      // There was a connection error of some sort
      if (args.error) {
        args.error();
      }
      if (args.always) {
        args.always(false);
      }
    };
    if (args.method.toLowerCase() == "post") {
      request.send(args.params);
    } else {
      request.send();
    }
  }

  //Pad
  function pad_int(n) {
    n = "" + n;
    return ("00" + n).slice(-Math.max(2, n.length));
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Supports
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function object_fill_polyfill($cont) {
    if (support.objectFit) return;
    var $fits = ($cont || $body).find(".fit");
    if ($fits.length) {
      $fits.each(function (el) {
        var $el = $(el);
        var src = $el.attr("src") || $el.attr("data-flickity-lazyload");
        if (src) {
          $el
            .parent()
            .css("background-image", "url(" + src + ")")
            .addClass("fitBG");
          $el.remove();
        }
      });
    }
  }
  object_fill_polyfill();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Ajax
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function init_ajax($cont) {
    $cont = $cont || $body;
    $cont.on('click', 'a[href^="' + url.home + '"]:not([href^="' + url.content + '"])', ajax_trigger);
  }
  init_ajax();

  function ajax_all_scripts($cont) {
    $cont = $cont || $body;
    init_ajax($cont);
    sliders_init($cont);
    covers_init($cont);
    accs_init($cont);
    fs_init($cont);
    audio_init_links($cont);
    object_fill_polyfill($cont);
    audio_update_classes_active($cont);
  }

  function ajax_trigger(event) {
    var $this = $(this);
    if (
      !support.history ||
      ($this.hasClass("nav_link") && $this.get(0).nextElementSibling) ||
      $this.hasClass("js-acc-trigger") ||
      $this.data("fs") ||
      $this.hasClass("no-ajax")
    )
      return;
    event.preventDefault();
    if (!is_requeting) {
      closeSubMenu();
      $html.removeClass("has-menuMobilOpen");
      $nav_i.removeClass("is-active");
      $this.parents(".nav_i, .nav_si").addClass("is-active");
      var url = $this.attr("href");
      ajax_load_page(url);
    }
  }

  function ajax_load_page(url, pop) {
    cart_close();
    ajax({
      url: url,
      params: "is_ajax",
      before: function () {
        $main.css("height", $main.outerHeight() + "px");
        $main.empty();
        scrollTo(0, 400);
        is_requeting = true;
      },
      success: function (html) {
        if (!html) {
          window.location = url;
          return;
        }
        $main.removeAttr("style");
        $main.html(html);
        ajax_all_scripts($main);
        var $title = $main.find("title");
        var title = $title.html();
        $title.remove();
        var $lang = $main.find("#langsSwitcher");
        if ($lang.length) {
          var langHTML = $lang.html();
          $lang.remove();
          if ($langsSwitcher.length && langHTML) {
            $langsSwitcher.html(langHTML);
          }
        }
        $main.find("html").remove();
        tarteaucitron_update();
        if (!pop) {
          update_history({ url: url, title: title });
        }
      },
      error: function () {
        window.location = url;
      },
      always: function () {
        is_requeting = false;
      },
    });
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //History
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var currentPageUrl = "",
    // currentPageUrlRelative = window.location.pathname,
    currentPageUrlRelative = "",
    currentState = {},
    auto_pop_history = true;

  // Non-webkit browsers don't fire an initial popstate event
  if ("state" in window.history) {
    auto_pop_history = false;
  }

  set_history_vars();

  if (support.history && !auto_pop_history)
    window.history.replaceState(currentState, "", currentPageUrl);

  w.addEventListener("popstate", function (e) {
    if (!e.state || currentPageUrl == e.state.url) return;

    set_history_vars(e.state);

    ajax_load_page(e.state.url, true);

    if (currentState.title) {
      document.title = currentState.title;
    }
    if (typeof ga !== "undefined") {
      ga("send", "pageview", currentPageUrlRelative);
    }
  });

  function set_history_vars(state) {
    currentPageUrl = window.location.href;
    currentPageUrlRelative = currentPageUrl.replace(/^(?:\/\/|[^\/]+)*\//, "/");
    if (state) {
      currentState = state;
    } else if (window.history.state) {
      currentState = window.history.state;
    } else {
      currentState = {
        title: document.title,
        url: currentPageUrl,
      };
    }
  }

  function update_history(state) {
    if (!support.history) return;
    // if(state.url != window.location.href) {
    if (state.title) {
      document.title = state.title;
    }
    window.history.pushState(state, "", state.url);
    set_history_vars();
    if (typeof ga !== "undefined") {
      ga("send", "pageview", currentPageUrlRelative);
    }
    // }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $nav_links = $nav.find(".nav_link");
  var $nav_items = $nav.find(".nav_i");
  $nav_links.each(function (el) {
    $(el).on("click", trigger_nav_link);
  });

  function trigger_nav_link(event) {
    var $this = $(this);
    var $link_item = $this.closest(".nav_i");
    var $sub_menu = $link_item.find(".nav_sub");
    if ($sub_menu.length) {
      event.preventDefault();
    }
    if ($link_item.hasClass("is-open")) {
      $link_item.removeClass("is-open");
      if ($sub_menu.length) {
        $html.removeClass("has-subnavOpen");
      }
    } else {
      $nav_items.removeClass("is-open");
      $link_item.addClass("is-open");
      if ($sub_menu.length) {
        $html.addClass("has-subnavOpen");
      }
    }
  }

  function closeSubMenu() {
    $html.removeClass("has-subnavOpen");
    $nav_items.removeClass("is-open");
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var menuMobilTrigger = $("#menuTrigger");
  if (menuMobilTrigger.length) {
    menuMobilTrigger.on("click", trigger_menu_mobil);
  }

  function trigger_menu_mobil(e) {
    e.preventDefault();
    if ($html.hasClass("has-menuMobilOpen")) {
      $html.removeClass("has-menuMobilOpen");
      window.scrollTo(0, sauvScroll);
    } else {
      sauvScroll = scrollT;
      $html.addClass("has-menuMobilOpen");
    }
    // ffclass.toggle(html,'has-menuMobilOpen');
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sliders Flickity
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function sliders_init($cont) {
    var $sliders = ($cont || $main).find(".js-slider");
    if (!$sliders.length) return;

    $sliders.each(function (el) {
      slider_set(el);
    });
  }
  sliders_init();

  function slider_set(slider) {
    var $slider = $(slider);
    var bigSlider = $slider.hasClass("homeSlider");
    var lazyBg = $slider.data("lazybg");
    if (bigSlider && $slider.children().length < 2) return;

    var flkty = new Flickity(slider, {
      // cellSelector: '.slider_i',
      setGallerySize: !bigSlider,
      resize: !bigSlider,
      cellAlign: "left",
      contain: true,
      wrapAround: bigSlider,
      groupCells: !bigSlider, //ou 2
      // prevNextButtons: false,
      lazyLoad: lazyBg ? false : 1, //<img src="placeholder.jpg" data-flickity-lazyload="full.jpg" />
      bgLazyLoad: lazyBg ? 1 : false,
      pageDots: bigSlider,
      arrowShape: bigSlider
        ? "M53.7,5l13.8,13.8L46.9,39.6h44.4v20.8H46.9l20.8,20.8L53.7,95l-45-45L53.7,5z"
        : "M58.9,8.8L24,43.9h76v12.3H24l34.9,35.1l-8.8,8.8L0,50L50.1,0L58.9,8.8z",
    });
    if (bigSlider) {
      var $uiContainer = $('<div class="flickity-ui-wrapper"></div>');
      var $dots = $slider.find(".flickity-page-dots");
      var $prev = $slider.find(".flickity-prev-next-button.previous");
      var $next = $slider.find(".flickity-prev-next-button.next");
      $uiContainer.appendTo($slider).append($prev).append($dots).append($next);
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Cover youtube et viméo
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function covers_init($cont) {
    var $videosToCover = ($cont || $main).find(".js-video-cover");
    var nb_covers = $videosToCover.length;
    var cover_actual = 0;
    var nb_cover_parallel = 3;
    if (nb_covers) {
      cover_launch();
    }

    function cover_launch() {
      videosCover_get_imgs();
    }

    function videosCover_get_imgs() {
      for (var i = 0; i < nb_cover_parallel; i++) {
        videosCover_get_img(cover_actual);
      }
    }

    function next_covers() {
      if (!(cover_actual % nb_cover_parallel) && cover_actual < nb_covers) {
        // console.log('New');
        videosCover_get_imgs();
      }
    }

    function videosCover_get_img(idx) {
      if (idx >= nb_covers) return;
      cover_actual++;
      // console.log(idx,cover_actual);
      var $this = $videosToCover.eq(idx);
      var type = $this.data("type");
      var id = $this.data("id");

      if (type && id) {
        var img = false;
        if (type == "youtube") {
          img = "http://img.youtube.com/vi/" + id + "/mqdefault.jpg";
          if (img)
            $this
              .css("background-image", "url(" + img + ")")
              .addClass("has-img");
          next_covers();
        } if (type == "video") {
          img = $this.data("image");
          if (img)
            $this
              .css("background-image", "url(" + img + ")")
              .addClass("has-img");
          next_covers();
        } /*else if (type == "vimeo") {
          ajax({
            url: "https://vimeo.com/api/v2/video/" + id + ".json",
            json: true,
            success: function (data) {
              if (data && data.length > 0 && data[0].thumbnail_medium)
                $this
                  .css(
                    "background-image",
                    "url(" + data[0].thumbnail_large + ")"
                  )
                  .addClass("has-img");
            },
            always: function () {
              next_covers();
            },
          });
        }*/ else {
          next_covers();
        }
      } else {
        next_covers();
      }
    }
  }
  covers_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menus accordéons
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function accs_init($cont) {
    var $accs_triggers = ($cont || $main).find(".js-acc-trigger");
    $accs_triggers.each(function (el) {
      init_acc(el);
    });

    function acc_update_height($acc, $acc_text) {
      if (!support.transitionend) return;
      if ($acc.hasClass("is-closed")) {
        $acc_text.css("max-height", "1px");
      } else {
        $acc_text.css("max-height", $acc_text.get(0).scrollHeight + "px");
      }
    }

    function init_acc(link) {
      var $acc_trigger = $(link);
      var $acc = $acc_trigger.closest(".js-acc");
      var $acc_text = $acc.find(".js-acc-text");
      var $acc_parent = $acc.closest("[data-acc-parent]");
      var accToggle = $acc_parent.length
        ? $acc_parent.get(0).hasAttribute("data-toggle")
        : false;
      var accScroll = $acc_parent.length
        ? $acc_parent.get(0).hasAttribute("data-scroll")
        : false;
      var href_archive = $acc_parent.length
        ? $acc_parent.data("archive")
        : false;
      var title_archive = false;
      var title_acc = false;
      if (href_archive) {
        var $acc_h2 = $acc_trigger.find("h2");
        title_archive = $acc_parent.length ? $acc_parent.data("title") : false;
        title_acc = $acc.get(0).hasAttribute("data-title")
          ? $acc.data("title")
          : $acc_h2.length
            ? $acc_h2.text()
            : "";
      }
      if (!$acc.length || !$acc_text.length) return;
      if (!$acc.hasClass("is-active")) {
        $acc.addClass("is-closed");
      } else {
        $acc.removeClass("is-active");
        scrollTo($acc.offset().top - headerFixedH, 400);
      }
      // acc_update_height($acc, $acc_text);
      $acc.addClass("is-init");
      if (false && support.transitionend) {
        $acc_text.on(support.transitionend, transitionEndAcc);
      }
      $acc_trigger.on("click", function (event) {
        event.preventDefault();
        var $this = $(this);
        if ($acc.hasClass("is-closing") || $acc.hasClass("is-opening")) return;
        var href = $this.attr("href");
        if (href_archive && support.history && href) {
          if (!$acc.hasClass("is-closed")) {
            history.replaceState(null, null, href_archive);
            d.title = title_archive;
          } else {
            // var title = $this.find('h2').text();
            history.replaceState(null, null, href);
            if (title_acc) d.title = title_acc;
          }
        }
        if (false && support.transitionend) {
          if (accToggle) {
            $acc.siblings().each(function (el) {
              var $accBrother = $(el);
              if (!$accBrother.hasClass("is-closed")) {
                var $text_to_close = $accBrother.find(".js-acc-text");
                // $text_to_close.css('max-height', $text_to_close.get(0).scrollHeight+"px");
                // $accBrother.addClass('is-closed');
                $accBrother.addClass("is-closing");
                // setTimeout(function() {
                $text_to_close.css("max-height", "1px");
                // }, 100);
                // transitionEndAccManual($text_to_close);
              }
            });
          }
          // $acc_text.css('max-height', $acc_text.get(0).scrollHeight+"px");
          if (!$acc.hasClass("is-closed")) {
            $acc.addClass("is-closing");
            // setTimeout(function() {
            $acc_text.css("max-height", "1px");
            // }, 100);
          } else {
            $acc.addClass("is-opening");
            $acc_text.css("max-height", $acc_text.get(0).scrollHeight + "px");
          }
          // transitionEndAccManual($acc_text);
          // $acc.toggleClass('is-closed');
        } else {
          if (accToggle) {
            $acc.siblings().addClass("is-closed");
          }
          $acc.toggleClass("is-closed");
        }
        if (accScroll) {
          window.scrollTo(0, $acc.offset().top - headerFixedH);
        }
      });
    }

    function transitionEndAcc(e) {
      // e.stopPropagation();
      if (e.propertyName !== "max-height" && e.propertyName !== "maxHeight")
        return;
      // $(this).removeAttr('style').closest('.js-acc').toggleClass('is-closed').removeClass('is-closing is-opening');
      $(this)
        .closest(".js-acc")
        .toggleClass("is-closed")
        .removeClass("is-closing is-opening");
    }
    // function transitionEndAccManual($accText) {
    //   setTimeout(function() {
    //     $accText.closest('.js-acc').toggleClass('is-closed').removeClass('is-closing is-opening');
    //     // $accText.removeAttr('style');
    //   }, 500);
    // }
  }
  accs_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Fullscreen
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // console.log(sirba_galleries);
  var youtubeApiLoaded = false;
  var nextFSToLoad = false;
  var sirba_galleries = false;
  var music_pause_for_fs = false;
  var FS = function (el) {
    if (!el) return;
    var _this = this;
    _this.el = $(el);
    _this.valid = false;
    _this.type = _this.el.data("fs");
    _this.id = _this.el.data("id");
    _this.videoType = _this.el.data("type");
    _this.videoUrl = _this.el.data("url");

    if (_this.type == "video") {
      if (_this.id && _this.videoType && _this.videoUrl) {
        _this.valid = true;
        _this.player = false;
        _this.infos = {
          titre: _this.el.data("titre"),
          date: _this.el.data("date"),
          lieu: _this.el.data("lieu"),
        };
      } else {
        return;
      }
    } else if (_this.type == "galery") {
      if (
        _this.id &&
        sirba_galleries &&
        sirba_galleries[_this.id] &&
        sirba_galleries[_this.id].length
      ) {
        _this.imgs = sirba_galleries[_this.id];
        _this.nbSlides = _this.imgs.length;
        _this.valid = true;
        _this.flickity = false;
      } else {
        return;
      }
    } else {
      return;
    }
    _this.els = {};
    if (_this.valid) {
      _this.el.on("click", function (event) {
        event.preventDefault();
        _this.initFS();
      });
      _this.createFS();
    }
  };

  FS.prototype.initFS = function () {
    var _this = this;
    //Ajout du fullscreen
    _this.addFS();
    if (_this.type == "galery") {
      //Init flickity
      _this.initFlktyFS();
    } else {
      nextFSToLoad = _this;
      // Rafraîchissement Tarteaucitron pour affichage des vidéos
      tarteaucitron_update();
      // _this.loadApiFS();
      // console.log(audioPlayer.isPaused());
      if (audioPlayer && !audioPlayer.isPaused()) {
        music_pause_for_fs = true;
        audioPlayer.pause();
      }
    }
    //Gestion fermeture
    _this.closeManagerFS();
  };

  FS.prototype.createFS = function () {
    var _this = this;
    _this.els.fullscreen = $('<div class="fs" id="fs"></div>');
    _this.els.inner = $('<div class="fs_inner"></div>');
    if (_this.type == "galery") {
      _this.els.nav = $(
        '<div class="fs_nav"><span class="fs_lgd" id="fsLgde"></span><div class="fs_count txtB-20"><span class="fs_nb" id="fsIndex">01</span>/<span class="fs_nb" id="fsTotal">01</span></div></div>'
      );
    } else {
      _this.els.nav = $(
        '<div class="fs_nav"><span class="fs_title">' +
        (_this.infos.titre
          ? '<span class="txtB-20">' + _this.infos.titre + "</span>"
          : "") +
        (_this.infos.date
          ? '<span class="txtLt-15">' + _this.infos.date + "</span>"
          : "") +
        (_this.infos.lieu
          ? '<span class="txtLt-15">' + _this.infos.lieu + "</span>"
          : "") +
        "</span></div>"
      );
      // _this.els.player = $('<div class="fs_player"></div>');
      // _this.els.inner.append(_this.els.player);
    }
    _this.els.close = $(
      '<button type="button" class="fs_close" id="closeFS"><span class="srOnly">' +
      "Fermer" +
      ' </span><span class="icon-close"></span></button>'
    );

    _this.els.fullscreen.append(_this.els.close);
    _this.els.fullscreen.append(_this.els.nav);
    _this.els.fullscreen.append(_this.els.inner);

    //Stockage des objets/variables relatifs au slider
    _this.els.indexSlide = _this.els.fullscreen.find("#fsIndex");
    _this.els.nbSlides = _this.els.fullscreen.find("#fsTotal");
    _this.els.legende = _this.els.fullscreen.find("#fsLgde");

    //Création du slider
    if (_this.type == "galery") {
      _this.els.slider = $('<div class="fs_slider"></div>');
      _this.imgs.forEach(function (img, idx) {
        var slide = $('<div class="fs_slide has-loader is-loading"></div>');
        slide.html(
          '<img data-flickity-lazyload="' +
          img.src +
          '" alt="" /><span class="srOnly fs_caption">' +
          img.lgd +
          "</span>"
        );
        _this.els.slider.append(slide);
      });
    } else if (_this.videoType == "video") {
      _this.els.slider = $('<video controls width="250"><source src="' + _this.videoUrl + '" type="video/mp4" /></video >');
    } else {
      _this.els.slider = $('<div class="youtube_player" videoID="' + _this.id + '"></div>');
      //TODO
    }

    //Ajout du slider au fullscreen
    _this.els.inner.append(_this.els.slider);
  };

  FS.prototype.addFS = function () {
    var _this = this;
    $body.append(_this.els.fullscreen);
    sauvScroll = scrollT;
    window.setTimeout(function () {
      $html.addClass("is-scrollBlocked");
    }, 100);
  };

  FS.prototype.initFlktyFS = function () {
    var _this = this;
    if (_this.flickity) {
      _this.flickity.select(0, false, true);
    } else {
      // _this.els.slider.addClass('flickity-fs');
      _this.flickity = new Flickity(_this.els.slider.get(0), {
        cellSelector: ".fs_slide",
        setGallerySize: false,
        pageDots: false,
        lazyLoad: 1,
        wrapAround: true,
        arrowShape:
          "M53.7,5l13.8,13.8L46.9,39.6h44.4v20.8H46.9l20.8,20.8L53.7,95l-45-45L53.7,5z",
      });
      var $prev = _this.els.slider.find(".flickity-prev-next-button.previous");
      var $next = _this.els.slider.find(".flickity-prev-next-button.next");
      _this.els.nav.prepend($prev);
      _this.els.nav.append($next);
      _this.els.nbSlides.html(pad_int(_this.flickity.cells.length));
      _this.updateLgd(0);
      _this.flickity.on("cellSelect", function () {
        _this.updateFS();
      });
      _this.flickity.on("lazyLoad", function (event, cellElement) {
        $(cellElement).removeClass("is-loading");
      });
    }
    _this.els.slider.get(0).focus();
  };

  FS.prototype.updateFS = function () {
    var _this = this;
    _this.els.indexSlide.html(pad_int(_this.flickity.selectedIndex + 1));
    _this.updateLgd(_this.flickity.selectedIndex);
  };

  FS.prototype.updateLgd = function (idx) {
    var _this = this;
    if (_this.els.legende) _this.els.legende.html(_this.imgs[idx].lgd);
  };

  FS.prototype.closeManagerFS = function () {
    var _this = this;
    if (_this.els.close) {
      _this.els.close.off("click", closeFullscreen);
      _this.els.close.on("click", closeFullscreen);
    }
  };

  function closeFullscreen() {
    var activeFS = $("#fs");
    nextFSToLoad = false;
    if (!activeFS.length) return;
    //Gestion scroll body puis suppression du node et etc.
    $html.removeClass("is-scrollBlocked");
    // html.scrollTop = sauvScroll;
    window.scrollTo(0, sauvScroll);
    //Delay pour eviter qu'on voit que l'on vient d'en haut
    window.setTimeout(function () {
      //Suppression du node
      activeFS.remove();
    }, 50);
    //Redémarrer la lecture
    // if(audioPlayer) audioPlayer.play();
    // console.log(audioPlayer.isPaused());
    if (music_pause_for_fs && audioPlayer) {
      audioPlayer.play();
      music_pause_for_fs = false;
    }
  }

  /*
  FS.prototype.loadApiFS = function () {
    var _this = this;
    if (_this.videoType == "youtube") {
      if (youtubeApiLoaded) {
        onYouTubeIframeAPIReady();
      } else {
        youtubeApiLoaded = true;
        var tag = d.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = d.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    } else if (_this.videoType == "vimeo") {
      var url =
        "http://www.vimeo.com/api/oembed.json" +
        "?url=" +
        encodeURIComponent(_this.videoUrl) +
        "&callback=" +
        "onVimeoOembedReady" +
        "&autoplay=1";
      var tag = d.createElement("script");
      tag.src = url;
      var firstScriptTag = d.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  };
  */

  /*
  w.onYouTubeIframeAPIReady = function () {
    return;
    if (!nextFSToLoad) return;
    if (!nextFSToLoad.player) {
      nextFSToLoad.player = new YT.Player(nextFSToLoad.els.slider.get(0), {
        videoId: nextFSToLoad.id,
        playerVars: {
          rel: false,
          html5: true,
          autohide: true,
        },
        events: {
          onReady: onPlayerReady,
          // 'onStateChange': onPlayerStateChange
        },
      });
    }
  };


  w.onVimeoOembedReady = function (video) {
    if (!nextFSToLoad) return;
    if (!nextFSToLoad.player) {
      nextFSToLoad.els.inner.html(unescape(video.html));
      nextFSToLoad.player = true;
    }
    // if(audioPlayer) audioPlayer.pause();
    // document.getElementById('embed').innerHTML = unescape(video.html);
    // console.log(video);
  };

  function onPlayerReady(event) {
    event.target.playVideo();
    // console.log('Ready !');
  }
  */

  // function onPlayerStateChange(event) {
  // 	if (event.data == YT.PlayerState.PLAYING) {
  // 		// console.log('Playing');
  // 		if(audioPlayer) audioPlayer.pause();
  // 	}
  // 	// if (event.data == YT.PlayerState.PAUSED) {
  // 	// 	console.log('Paused');
  // 	// 	if(player) player.play();
  // 	// }
  // 	// if (event.data == YT.PlayerState.ENDED) {
  // 	// 	console.log('Ended');
  // 	// 	if(player) player.play();
  // 	// }
  // }

  function fs_init($cont) {
    var $gallerieNode = ($cont || $main).find("#sirba_galleries");
    var fsTriggers = ($cont || $main).find("[data-fs]");
    var fsTab = [];
    sirba_galleries = false;
    if ($gallerieNode.length) {
      try {
        sirba_galleries = JSON.parse($gallerieNode.data("json"));
      } catch (e) {
        sirba_galleries = false;
      }
      // console.log(sirba_galleries);
    }
    if (fsTriggers.length) {
      fsTriggers.each(function (el) {
        var newFS = new FS(el);
        if (newFS.valid) {
          fsTab.push(newFS);
        }
      });
    }
  }
  fs_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Audio
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var audioPlayer = $("#player");
  var playlist = $("#playlist");
  var $audioTrackTitle = $("#audioTrack");
  var playlistTracks = playlist.find("[data-mp3]");
  var allTracks;
  var $actualTrack = false;
  var $actualPlaylist = false;
  if (playlistTracks.length && audioPlayer.length) {
    audio_init_player();
  }

  function audio_init_player() {
    audioPlayer = plyr.setup(audioPlayer.get(0), {
      loadSprite: false,
      // volume: 5,
      tooltips: { controls: false, seek: false },
      selectors: {
        container: ".player",
        controls: {
          container: null,
          wrapper: ".player_controls",
        },
        labels: "label",
        progress: {
          container: ".player_progress",
          buffer: ".player_buffer",
          played: ".player_played",
        },
        currentTime: ".player_currentTime",
        duration: ".player_duration",
      },
      html: [
        "<div class='player_controls'>",
        "<span class='player_btns'>",
        "<button type='button' id='audioPrev'>",
        "<span class='icon-fast-backward'></span>",
        "<span class='srOnly'>Previous song</span>",
        "</button>",
        "<button type='button' data-plyr='play'>",
        "<span class='icon-play'></span>",
        "<span class='srOnly'>Play</span>",
        "</button>",
        "<button type='button' id='audioNext'>",
        "<span class='icon-fast-forward'></span>",
        "<span class='srOnly'>Next song</span>",
        "</button>",
        "</span>",
        "<span class='player_time'>",
        "<span class='srOnly'>Current time</span>",
        "<span class='player_currentTime'>00:00</span>",
        "</span>",
        "<span class='player_bar'>",
        "<span class='player_progress'>",
        "<label for='seek{id}' class='srOnly'>Seek</label>",
        "<input id='seek{id}' class='player_seek' type='range' min='0' max='100' step='0.1' value='0' data-plyr='seek'>",
        "<progress class='player_played' max='100' value='0' role='presentation'></progress>",
        "</span>",
        "</span>",
        "<span class='player_time'>",
        "<span class='srOnly'>Duration</span>",
        "<span class='player_duration'>00:00</span>",
        "</span>",
        "</div>",
      ].join(""),
      classes: {
        setup: "player-setup",
        ready: "player-ready",
        videoWrapper: "player_videoWrapper",
        embedWrapper: "player_videoEmbed",
        type: "player-{0}",
        stopped: "player-stopped",
        playing: "player-playing",
        muted: "player-muted",
        loading: "player-loading",
        hover: "player-hover",
        tooltip: "player_tooltip",
        hidden: "srOnly",
        hideControls: "player-hideControls",
        isIos: "player-isIos",
        isTouch: "player-isTouch",
        captions: {
          enabled: "player-captionsEnabled",
          active: "player-captionsActive",
        },
        fullscreen: {
          enabled: "player-fullscreenEnabled",
          active: "player-fullscreenActive",
        },
        tabFocus: "tabFocus",
      },
    });
    audioPlayer = audioPlayer.length ? audioPlayer[0] : false;
    audio_init_links_playlist();
    audio_init_links();
    audio_prev_next_init();
    audioPlayer.on("playing", playAudio);
    audioPlayer.on("pause", pauseAudio);
    audioPlayer.on("ended", endAudio);
    audioPlayer.source({
      type: "audio",
      title: playlistTracks.first().find("td").eq(1).text(),
      sources: [
        {
          src: playlistTracks.first().data("mp3"),
          type: "audio/mp3",
        },
      ],
    });
    $actualTrack = playlistTracks.first();
    audio_trigger_playlist();
    audio_maj_title();
    audioPlayer.pause();
    // console.log(audioPlayer);
  }

  function audio_prev_next_init() {
    var $audioPrev = $("#audioPrev");
    var $audioNext = $("#audioNext");
    if ($audioPrev.length) $audioPrev.on("click", audio_prev_track);
    if ($audioNext.length) $audioNext.on("click", audio_next_track);
  }

  function audio_maj_title() {
    if (!$actualTrack.length) return;
    var titleTrack = $actualTrack.is("tr")
      ? $actualTrack.find("[data-title]").text()
      : $actualTrack.text();
    $audioTrackTitle.text(titleTrack).attr("title", titleTrack);
  }
  // function audio_get_actual_playlist() {
  //   if(!$actualTrack.length) return;
  //   if($actualTrack.parent().is('li')) {
  //     return $actualTrack.closest('ul').children('[data-mp3]');
  //   } else {
  //     return $actualTrack.parent().children('[data-mp3]');
  //   }
  //   return  false;
  // }

  function audio_prev_track(event) {
    if (event) event.preventDefault();
    if (!$actualTrack.length) return;
    if ($actualTrack.parent().is("li")) {
      $actualTrack.parent().prev().children().trigger("click");
    } else {
      $actualTrack.prev().trigger("click");
    }
  }

  function audio_next_track(event) {
    if (event) event.preventDefault();
    if (!$actualTrack.length) return;
    if ($actualTrack.parent().is("li")) {
      $actualTrack.parent().next().children().trigger("click");
    } else {
      $actualTrack.next().trigger("click");
    }
  }

  function audio_init_links_playlist() {
    playlistTracks.on("click", audio_trigger_a_track);
  }

  function audio_init_links($cont) {
    allTracks = ($cont || $main).find("[data-mp3]");
    allTracks.on("click", audio_trigger_a_track);
  }

  function audio_trigger_a_track(event) {
    event.preventDefault();
    var $this = $(this);
    if ($this.hasClass("is-playing")) {
      audioPlayer.pause();
      // $this.removeClass('is-playing');
    } else {
      if (
        $actualTrack.length &&
        $actualTrack.data("mp3") == $this.data("mp3")
      ) {
        audioPlayer.play();
      } else {
        // playlistTracks.removeClass('is-playing');
        // allTracks.removeClass('is-playing');
        audioPlayer.stop();
        // audioPlayer.pause();
        audioPlayer.source({
          type: "audio",
          title: $this.is("tr")
            ? $this.find("td").first().text()
            : $this.text(),
          sources: [
            {
              src: $this.data("mp3"),
              type: "audio/mp3",
            },
          ],
        });
        audioPlayer.play();
        // $this.addClass('is-playing');
        $actualTrack = $this;
      }
    }
  }

  function audio_trigger_playlist() {
    var playlistTriggers = $header.find(".js-playlist");
    if (playlistTriggers.length) {
      playlistTriggers.on("click", function (event) {
        event.preventDefault();
        $html.toggleClass("has-playlistOpened");
        $html.toggleClass("is-scrollBlocked");
      });
    }
  }

  function pauseAudio(event) {
    // console.log(audioPlayer);
    playlistTracks.removeClass("is-playing");
    allTracks.removeClass("is-playing");
  }

  function playAudio(event) {
    // console.log('play');
    if (!$actualTrack.length) return;
    audio_maj_title();
    audio_update_classes_active();
  }

  function endAudio(event) {
    audio_next_track();
  }

  function audio_update_classes_active($cont) {
    playlistTracks.removeClass("is-playing");
    allTracks.removeClass("is-playing");
    if (!$actualTrack.length) return;
    ($cont || $body)
      .find('[data-mp3="' + $actualTrack.data("mp3") + '"]')
      .addClass("is-playing");
  }

  function closePlaylist() {
    $html.removeClass("has-playlistOpened");
    $html.removeClass("is-scrollBlocked");
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Formulaire
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

  function form_init($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $cont
      .find(".form_field input, .form_field textarea")
      .on("blur", function (event) {
        if (this.value) $(this).addClass("has-content");
        else $(this).removeClass("has-content");
      })
      .trigger("blur");
    $cont
      .find(".form_field select")
      .on("change", function (event) {
        if (this.value) $(this).addClass("has-content");
        else $(this).removeClass("has-content");
      })
      .trigger("change");
    $cont
      .find('[type="checkbox"][data-check-control]')
      .each(function (el) {
        form_part_change(el);
      })
      .on("click", function (event) {
        form_part_change(this);
      });
  }
  form_init();

  function form_part_change(checkbox) {
    if (checkbox.checked) {
      form_part_show($("#" + $(checkbox).attr("data-check-control")));
    } else {
      form_part_hide($("#" + $(checkbox).attr("data-check-control")));
    }
  }

  function form_part_hide($cont) {
    $cont.addClass("is-hidden");
    $cont.find("input, select, textarea").attr("disabled", "disabled");
  }

  function form_part_show($cont) {
    $cont.removeClass("is-hidden");
    $cont.find("input, select, textarea").removeAttr("disabled");
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Panier
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $cart = $("#cart");

  $body.find(".js-cart-open").on("click", cart_open);
  $cart.on("click", ".js-cart-close", cart_close);
  $("#cartOverlay").on("click", cart_close);

  function cart_open(event) {
    if (event) event.preventDefault();
    $html.addClass("has-cart-open");
  }

  function cart_close(event) {
    if (event) event.preventDefault();
    $html.removeClass("has-cart-open");
  }

  const cart_action = async (params) => {
    params.action = "cart_action";
    params.lang = constants.lang;
    if (params.cart_action == "add") {
      cart_open();
      $cart.find(".cart_cont").addClass("has-loader").addClass("is-loading");
    }
    const path = new URL(url.ajax);
    path.search = new URLSearchParams(params);
    try {
      const res = await fetch(path.toString());
      const data = await res.json();
      if (data.success) {
        $header.find("[data-cart-nb]").attr("data-cart-nb", data.nb_products);
        $cart.find(".cart_cont").html(data.cart_content);
      }
    } catch (error) {
      console.log("error", error);
    }
    $cart
      .find(".cart_cont")
      .removeClass("has-loader")
      .removeClass("is-loading");
  };

  function cart_action_init() {
    if (!$cart.length) return;

    // Récupère le panier au chargement de la page
    cart_action({ cart_action: 'get_cart' });

    $body.on("click", ".js-cart-action", function (event) {
      event.preventDefault();
      var params = {};
      if (this.href) {
        params = getQueryVariables(this.href);
      } else {
        params.cart_action =
          this.hasAttribute("data-action") && this.getAttribute("data-action");
        params.id_product =
          this.hasAttribute("data-id") && this.getAttribute("data-id");
      }
      if (params.cart_action && params.id_product) cart_action(params);
    });
  }
  cart_action_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Formulaire : sections
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $formSections = $main.find(".js-tabs-section");
  var formEdited = false;
  $formSections.first().removeAttr("aria-hidden");
  $main.on("click", "[data-form-section]", function (event) {
    event.preventDefault();
    var $target = $("#" + $(this).attr("data-form-section"));
    if (!$target.length || !$target.get(0).hasAttribute("aria-hidden")) return;
    form_section_leave($target, this.hasAttribute("data-validate"));
  });

  function form_section_leave($target, needValidation) {
    var errors = [];
    if (needValidation) {
      errors = form_section_validate(
        $formSections.filter(':not([aria-hidden="true"])').first()
      );
    }
    if (errors && errors.length) {
      console.log(errors);
      return;
    }
    $formSections.attr("aria-hidden", "true");
    $target.removeAttr("aria-hidden");
    $main.find(".pageNav button[disabled]").removeAttr("disabled");
    $main.find(".pageNav .is-active").removeClass("is-active");
    $main = jQuery($main);
    const $btns = $main.find(".pageNav [data-form-section]");
    const $btn = $btns.filter(
      '[data-form-section="' + $target.get(0).id + '"]'
    );
    $btn.closest("li").addClass("is-active");
    const idxOfBtn = $btns.index($btn);
    const $filtered_btns = $btns.slice(idxOfBtn + 1, $btns.length);
    $filtered_btns.attr("disabled", "disabled");
    scrollToEl($main.find(".pageNav"));
    $html.addClass("is-form-edited");
    jQuery($main.find(".pageNav .bg2")).animate({ scrollLeft: $btn.closest("li").position().left });
  }

  function form_section_validate($section) {
    var errors = [];
    $section
      .find(
        ".form:not(.is-hidden) input,.form:not(.is-hidden) select,.form:not(.is-hidden) textarea"
      )
      .each(function (el) {
        if (!el.checkValidity()) {
          $(el).closest(".form_field,.form_check").addClass("is-error");
          if (!errors.length) {
            scrollToEl($(el), 30);
          }
          errors.push(el.name);
        } else {
          $(el).removeClass("is-error");
        }
      });
    return errors;
  }

  $main.on("focus", "input,select,textarea", function (event) {
    $(this).closest(".form_field,.form_check").removeClass("is-error");
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Formulaire : update element si changement de certains input
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $main.on(
    "change",
    "input[data-update],textarea[data-update],select[data-update]",
    function (event) {
      if (
        this.getAttribute("data-update").indexOf("billing") >= 0 ||
        this.getAttribute("data-update").indexOf("shipping") >= 0
      ) {
        form_update_billing();
        form_update_shipping();
      }
      if (this.getAttribute("data-update").indexOf("prices") >= 0) {
        form_update_prices();
      }
    }
  );
  form_update_billing();
  form_update_shipping();

  function form_update_billing() {
    var $updateEls = $('[data-checkout-cont="address-billing"]');
    var $checkoutForm = $("#form-checkout");
    var infos = [];
    if (!$checkoutForm.length) return;
    infos.push(
      $checkoutForm.find('[name="fname"]').val() +
      " " +
      $checkoutForm.find('[name="lname"]').val()
    );
    infos.push($checkoutForm.find('[name="societe"]').val());
    infos.push($checkoutForm.find('[name="address"]').val());
    infos.push(
      $checkoutForm.find('[name="postal"]').val() +
      " " +
      $checkoutForm.find('[name="city"]').val()
    );
    if ($checkoutForm.find('[name="country"]').val() != "fr")
      infos.push(
        $checkoutForm.find('[name="country"]').find("option:checked").text()
      );
    if ($checkoutForm.find('[name="tva"]').val())
      infos.push("no TVA " + $checkoutForm.find('[name="tva"]').val());
    infos.push($checkoutForm.find('[name="email"]').val());
    infos.push($checkoutForm.find('[name="phone"]').val());
    infos = infos
      .map(function (v) {
        return v.trim();
      })
      .filter(function (v) {
        return v != "";
      });
    $updateEls.html(infos.join("<br>"));
  }

  function form_update_shipping() {
    var $updateEls = $('[data-checkout-cont="address-shipping"]');
    var $checkoutForm = $("#form-checkout");
    var infos = [];
    var shippingPrefix = $checkoutForm
      .find('[name="shipping-different"]')
      .is(":checked")
      ? "shipping-"
      : "";
    if (!$checkoutForm.length) return;
    infos.push(
      $checkoutForm.find('[name="' + shippingPrefix + 'fname"]').val() +
      " " +
      $checkoutForm.find('[name="' + shippingPrefix + 'lname"]').val()
    );
    infos.push(
      $checkoutForm.find('[name="' + shippingPrefix + 'societe"]').val()
    );
    infos.push(
      $checkoutForm.find('[name="' + shippingPrefix + 'address"]').val()
    );
    if (shippingPrefix)
      infos.push(
        $checkoutForm
          .find('[name="' + shippingPrefix + 'address-complement"]')
          .val()
      );
    infos.push(
      $checkoutForm.find('[name="' + shippingPrefix + 'postal"]').val() +
      " " +
      $checkoutForm.find('[name="' + shippingPrefix + 'city"]').val()
    );
    if (
      $checkoutForm.find('[name="' + shippingPrefix + 'country"]').val() != "fr"
    )
      infos.push(
        $checkoutForm
          .find('[name="' + shippingPrefix + 'country"]')
          .find("option:selected")
          .text()
      );
    infos = infos
      .map(function (v) {
        return v.trim();
      })
      .filter(function (v) {
        return v != "";
      });
    $updateEls.html(infos.join("<br>"));
  }

  var pricesRequest = false;
  const form_update_prices = async () => {
    // var $updateEls = $('[data-checkout-cont="address-billing"]');
    var $checkoutForm = $("#form-checkout");
    var countryLivr = $checkoutForm
      .find('[name="shipping-different"]')
      .is(":checked")
      ? $checkoutForm.find('[name="shipping-country"]').val()
      : $checkoutForm.find('[name="country"]').val();
    countryLivr = countryLivr && countryLivr != "" ? countryLivr : "fr";
    if (pricesRequest) pricesRequest.abort();
    const path = new URL(url.ajax);
    path.search = new URLSearchParams({
      action: "get_cart_prices_json",
      country: countryLivr,
    });
    try {
      const res = await fetch(path.toString());
      const data = await res.json();
      if (data.prices) {
        $('[data-checkout-cont="prix_livr_f"]').text(data.prices.prix_livr_f);
        $('[data-checkout-cont="prix_total_f"]').text(data.prices.prix_total_f);
        $('[data-checkout-cont="prix_final_f"]').text(data.prices.prix_final_f);
        $('[data-checkout-cont="total_tva_f"]').text(data.prices.total_tva_f);
        $('[data-checkout-cont="country_name"]').text(data.country_name);
      }
    } catch (error) {
      console.log("error : ", error);
    }
  };


  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Stripe
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $formCheckout = $('#form-checkout');
  var stripe = false;
  var stripeElements = false;
  var stripeCard = false;
  var paymentInProgress = false;

  // https://stripe.github.io/elements-examples/fr/
  // https://github.com/stripe/elements-examples/blob/master/js/example2.js
  // https://stripe.com/docs/stripe-js/reference#element-types
  function init_stripe() {
    if (!$("#stripe-card-element").length) { return; }
    var stripeArgs = {
      hidePostalCode: true,
      // hideIcon: true,
      // iconStyle: 'solid',
      style: {
        base: {
          // Add your base input styles here. For example:
          fontSize: '16px',
          color: '#4D4D4D',
          '::placeholder': {
            color: '#9B9B9B',
          },
        }
      }
    };
    stripe = Stripe(constants.stripe_pk);
    stripeElements = stripe.elements();
    stripeCard = stripeElements.create('card', stripeArgs);
    stripeCard.mount('#stripe-card-element');
    $formCheckout.find('[type="submit"]').attr('disabled', 'disabled');
    stripeCard.addEventListener('change', function (event) {
      var $stripeErrors = $('#stripe-card-errors');
      if (event.error) {
        $stripeErrors.text(event.error.message);
        $formCheckout.find('[type="submit"]').attr('disabled', 'disabled');
      } else {
        $stripeErrors.text('');
        $formCheckout.find('[type="submit"]').removeAttr('disabled');
      }
    });
  }
  init_stripe();

  function stripe_payment() {
    if (paymentInProgress) return;
    paymentInProgress = true;
    // $formCheckout.find('[type="submit"]').addClass('has-loader').addClass('has-loader-s').addClass('has-loader-white').addClass('is-loading');
    var stripeBillingDetails = {
      name: $formCheckout.find('[name="fname"]').val() + ' ' + $formCheckout.find('[name="lname"]').val(),
      address: {
        city: $formCheckout.find('[name="city"]').val(),
        country: $formCheckout.find('[name="country"]').val(), // code du pays sur 2 lettres
        line1: $formCheckout.find('[name="address"]').val(),
        //line2       : ,
        postal_code: $formCheckout.find('[name="postal"]').val(),
        //state       : ,
      },
      email: $formCheckout.find('[name="email"]').val(),
      phone: $formCheckout.find('[name="phone"]').val(),
    };
    // console.log(stripeBillingDetails);

    stripe.handleCardPayment(
      $formCheckout.data('secret'), stripeCard, {
      payment_method_data: {
        billing_details: stripeBillingDetails
      }
    }
    ).then(function (result) {
      // console.log(result);
      if (result.error) {
        var $stripeErrors = $('#stripe-card-errors');
        $stripeErrors.text(result.error.message);
        paymentInProgress = false; //Si réussi on ne remet pas la variable a false, pas besoin car rechargement page
        $formCheckout.find('[type="submit"]').removeClass('has-loader').removeClass('has-loader-s').removeClass('has-loader-white').removeClass('is-loading').removeAttr('disabled');
      } else {
        // $formCheckout.append( '<input type="hidden" name="intent" value="'+$formCheckout.data('intent')+'">' );
        // $formCheckout.submit();
        // console.log('paiment succès');
        if ($formCheckout.data('command_hash_link')) {
          window.location.href = $formCheckout.data('command_hash_link');
        }
      }
    });
  }

  //On bloc la soummission, on soumet que si clic sur bouton
  $body.on('submit', '#form-checkout', function (event) {
    var $activeSection = $formCheckout.find('.js-tabs-section:not([aria-hidden="true"])').first();
    var $nextSectionBtn = $activeSection.find('.cartPage_submit button[data-form-section]').last();
    if (paymentInProgress) {
      return;
    } else if (!$activeSection.length) {
      event.preventDefault();
    } else if ($nextSectionBtn.length) {
      event.preventDefault();
      $nextSectionBtn.trigger('click');
    } else if ($activeSection.find("#stripe-card-element").length) {
      event.preventDefault();
      checkout_submit();
    }
  });

  const checkout_submit = async () => {
    if (!$formCheckout.length || paymentInProgress) {
      return;
    }
    paymentInProgress = true;
    $formCheckout.find('[type="submit"]').addClass('has-loader').addClass('has-loader-s').addClass('has-loader-white').addClass('is-loading').attr('disabled', 'disabled');
    $('#stripe-card-errors').text('');

    const datas = new URLSearchParams(new FormData($formCheckout[0]));
    datas.append("action", "get_stripe_payment_intent");
    try {
      const res = await fetch(url.ajax, { body: datas, method: 'POST' });
      const data = await res.json();
      if (data) {
        paymentInProgress = false;
        if (data.error) {
          $('#stripe-card-errors').text(data.error);
          $formCheckout.find('[type="submit"]').removeClass('has-loader').removeClass('has-loader-s').removeClass('has-loader-white').removeClass('is-loading');
        } else {
          $formCheckout.data('intent', data.intent);
          $formCheckout.data('secret', data.secret);
          $formCheckout.data('command_hash_link', data.command_hash_link);
          $formCheckout.find('[name="intent"]').remove();
          $formCheckout.append('<input type="hidden" name="intent" value="' + data.intent + '">');
          stripe_payment();
        }
      }
    } catch (error) {
      $formCheckout.find('[type="submit"]').removeClass('has-loader').removeClass('has-loader-s').removeClass('has-loader-white').removeClass('is-loading');
      console.log("error : ", error);
    }
  }


  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Newsletter : protection recaptcha
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function recaptcha_onload() {
    $('#newsletter').addClass('recaptcha_loaded');
  }

  $main.on("submit", "#newsletter_form", function (e) {
    var $form = $("#newsletter_form");
    e.preventDefault();
    if (typeof window.grecaptcha === 'undefined') { return; }
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute("6LczrPseAAAAAJb4E_yr2CatxRuPHHJAQNX-zl4m", {
          action: "submit",
        })
        .then(function (token) {
          $form.append(
            '<input type="hidden" name="form_captcha" value="' + token + '" /> '
          );
          $form.append('<input type="hidden" name="contact" value="1" /> ');
          $main.off("submit");
          $form.get(0).submit();
        });
    });
  });


  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Keys event
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  d.addEventListener("keydown", function (e) {
    if (e.keyCode == 27) {
      closeFullscreen();
      closePlaylist();
      cart_close();
    }
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sticky header
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var offsetHeader =
    $header_logo.get(0).getBoundingClientRect().top +
    $header_logo.outerHeight();
  function maj_header() {
    offsetHeader =
      $header_logo.get(0).getBoundingClientRect().top +
      $header_logo.outerHeight();
    if (offsetHeader < 0 && !$html.hasClass("has-stickyHeader")) {
      $html.addClass("has-stickyHeader");
      $header_logo.css("margin-bottom", $nav.outerHeight() + "px");
    } else if (offsetHeader >= 0 && $html.hasClass("has-stickyHeader")) {
      $html.removeClass("has-stickyHeader");
      $header_logo.removeAttr("style");
    }
  }
  maj_header();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Modale alerte info
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  const $modale = $(".alert_modale");
  const close_modale = () => {
    $body.removeClass("hasModale");
    $modale.addClass("is-hidden");
    local.is_modale_hidden = true;
    // Syntaxe « 1_000 » : Voir https://www.javascripttutorial.net/es-next/javascript-numeric-separator/
    local.hidden_time = Date.now() / 1_000;
    $modale.attr("aria-hidden", true);
    $body.attr("aria-hidden", false);
  };
  if ($modale) {
    const isHidden = local.is_modale_hidden;
    const hiddenTime = local.hidden_time || 0;
    // Syntaxe « 1_000 » : Voir https://www.javascripttutorial.net/es-next/javascript-numeric-separator/
    const dateNow = Date.now() / 1_000;
    const twoDays = 172_800;
    if (!isHidden || dateNow - hiddenTime > twoDays) {
      $body.addClass("hasModale");
      $modale.removeClass("is-hidden");
      $modale.attr("aria-hidden", false);
      $modale.trigger("focus");
      $body.attr("aria-hidden", true);
      local.is_modale_hidden = false;
      delete local.hidden_time;
    }
    $modale.find(".alert_modale_close").on("click", close_modale);
    $modale.find(".alert_modale_link").on("click", close_modale);
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function onResize() {
    update_dimensions();
    maj_header();
  }
  w.addEventListener("resize", onResize, false);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function onScroll() {
    update_scroll();
    maj_header();
  }
  w.addEventListener("scroll", onScroll, false);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Tarteaucitron
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  tarteaucitronCustomText = {
    acceptAll: "Accepter",
    allowAll: "Accepter",
    denyAll: "Refuser",
    alertBigPrivacy:
      "Ce site utilise des cookies et vous donne le <br>contrôle sur ceux que vous souhaitez activer",
  };
  tarteaucitron.init({
    privacyUrl: "" /* Privacy policy url */,

    hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
    cookieName: "tarteaucitronsirba" /* Cookie name */,

    orientation: "bottom" /* Banner position (top - bottom) */,

    showAlertSmall: false /* Show the small banner on bottom right */,
    cookieslist: false /* Show the cookie list */,

    showIcon: true /* Show cookie icon to manage cookies */,
    iconPosition:
      "BottomRight" /* BottomRight, BottomLeft, TopRight and TopLeft */,

    adblocker: false /* Show a Warning if an adblocker is detected */,
    closePopup: false /* Show a close X on the banner */,
    DenyAllCta: true /* Show the deny all button */,
    AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
    highPrivacy: true /* HIGHLY RECOMMANDED Disable auto consent */,

    handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

    removeCredit: true /* Remove credit link */,
    moreInfoLink: true /* Show more info link */,

    useExternalCss: true /* If false, the tarteaucitron.css file will be loaded */,
    useExternalJs: false /* If false, the tarteaucitron.js file will be loaded */,

    //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

    readmoreLink: "" /* Change the default readmore link */,

    mandatory: false /* Show a message about mandatory cookies */,
  });

  (tarteaucitron.job = tarteaucitron.job || []).push("youtube");

  tarteaucitron.user.analyticsUa = 'UA-86508189-1';
  (tarteaucitron.job = tarteaucitron.job || []).push('analytics');

  tarteaucitron.user.facebookpixelId = '2525087847775383';
  (tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');

  tarteaucitron.user.recaptchaapi = '6LczrPseAAAAAJb4E_yr2CatxRuPHHJAQNX-zl4m';
  tarteaucitron.user.recaptchaOnLoad = recaptcha_onload;
  (tarteaucitron.job = tarteaucitron.job || []).push('recaptcha');

  // Force le rechargement des vidéos & boutons d’autorisation
  function tarteaucitron_update() {
    if (typeof tarteaucitron !== 'undefined') {
      if (typeof tarteaucitron.job !== 'undefined') {
        tarteaucitron.job.forEach(function (e) {
          tarteaucitron.job.push(e);
        });
      }
      var allowBtns = document.getElementsByClassName("tarteaucitronAllow");
      if (allowBtns) {
        for (let i = 0; i < allowBtns.length; i++) {
          tarteaucitron.addClickEventToElement(allowBtns[i], function () {
            tarteaucitron.userInterface.respond(this, true);
          });
        }
      }
    }
  }
})(window);
